"use client";
import Head from "next/head";
import Link from "next/link";
import React from "react";
import KrishiJotnoHero from "src/components/Krishijotno/Heor";
import HowIt from "src/components/Krishijotno/HowIt";
import Header from "src/components/Langing/Header";

function index() {
  return (
    <div>
      <Head>
        <title>AgriCare Global || krishiJotno </title>
      </Head>
      <Header></Header>

      <KrishiJotnoHero></KrishiJotnoHero>
      <HowIt />
    </div>
  );
}

export default index;
